import { Observable, observe, Scope } from 'wdc-cube'
import { AcaoType, CondicaoRow } from './regra.types'

@Observable
export class RegraFormScope extends Scope {
    @observe() idSelected = 0 as number
    @observe() idCondicaoSelecionada = 0 as number

    @observe() nome = '' as string
    @observe() acao = 'ALERTAR' as AcaoType
    @observe() rating1 = 0 as number
    @observe() rating2 = 0 as number
    @observe() enviarNotificacao = false as boolean
    @observe() emailsNotificacao = '' as string
    @observe() condicoes = [] as CondicaoRow[]

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION

    onAddCondicao = Scope.ASYNC_ACTION
    onEditCondicao = Scope.ASYNC_ACTION
    onDeleteCondicao = Scope.ASYNC_ACTION
}

export default RegraFormScope
